import { MagnificPopup } from '../dynamic-imports/MagnificPopup';

export default class extends MagnificPopup {
  constructor({ el }) {
    super(el, {
      type: 'inline',
      midClick: true,
      mainClass: el.hasAttribute('data-class') ? el.getAttribute('data-class') : '',
      fixedContentPos: true
    });
  }
}
